import { Injectable } from '@angular/core';
import { find } from 'lodash';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { NavigationService } from './navigation.service';
import { Location } from '@angular/common';

@Injectable()
export class ImageGalleryService {
  private _isGalleryOpen: boolean = false;
  private _gallery;
  private _galleryIndex;
  private _selectedImage;
  private _onOpen: BehaviorSubject<any>
  public readonly onOpen: Observable<any>;
  private _onClose: BehaviorSubject<any>
  public readonly onClose: Observable<any>;
  private _onChangeImage: BehaviorSubject<any>
  public readonly onChangeImage: Observable<any>;

  constructor(
    private NavigationService: NavigationService,
    private location: Location
  ) {
    this._onOpen = new BehaviorSubject(true);
    this.onOpen = this._onOpen.asObservable();

    this._onClose = new BehaviorSubject(true);
    this.onClose = this._onClose.asObservable();

    this._onChangeImage = new BehaviorSubject(true);
    this.onChangeImage = this._onChangeImage.asObservable();
  }

  get isGalleryOpen(): boolean {
    return this._isGalleryOpen;
  }
    
  set isGalleryOpen(isGalleryOpen: boolean) {
    this._isGalleryOpen = isGalleryOpen;
  }

  get gallery() {
    return this._gallery;
  }
    
  set gallery(gallery) {
    this._gallery = gallery;
  }

  get galleryIndex() {
    return this._galleryIndex;
  }
    
  set galleryIndex(galleryIndex) {
    this._galleryIndex = galleryIndex;
  }

  get selectedImage() {
    return this._selectedImage;
  }
    
  set selectedImage(selectedImage) {
    this._selectedImage = selectedImage;
  }

  public openSingleGallery(selectedImage) {
    this.selectedImage = selectedImage;
    this.isGalleryOpen = true;
    this.openGallery();
  }

  public openMultiGallery(imageIndex) {
    this.galleryIndex = imageIndex;
    this.isGalleryOpen = true;
    this.openGallery();
  }

  private openGallery() {
    document.getElementsByTagName('app-nav-bar')[0]['style']['zIndex'] = -1;
    this._onOpen.next(true);
  }

  closeGallery() {
    this.NavigationService.onGalleryClose();
    let path = this.location.path().replace(/(\/gallery|\/image)\/[^\/]*/, '');
    this.location.go(path);
    this.isGalleryOpen = false;
    this.galleryIndex = null;
    this.selectedImage = null;
    document.getElementsByTagName('app-nav-bar')[0]['style']['zIndex'] = 20;
    this._onClose.next(true);
    this.NavigationService.isHidden = false;
  }

  onChangeImageEvent(index) {
    this._onChangeImage.next(index);
  }
}



// WEBPACK FOOTER //
// ./src/app/image-gallery.service.ts